module.exports = __webpack_public_path__ + "img/watermark.4644c136.png";